<template>
  <b-modal
    ref="modal"
    size="xl"
    hide-footer
    title="Modificar AVL"
    @hidden="reset"
    lazy
  >
    <form
      v-promise-btn="{ action: 'submit' }"
      @submit.prevent="submit"
      v-if="avl"
    >
      <div class="container h-100">
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label for="modelo">ID</label>
              <input
                v-model="avl.id_avl"
                disabled
                type="text"
                class="form-control"
                id="id"
              />
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label for="imei">Fecha de Ingreso</label>
              <input
                v-model="avl.fecha_ingreso"
                disabled
                type="datetime-local"
                class="form-control"
                id="fecha_ingreso"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label for="imei">IMEI</label>
              <input
                disabled
                v-model="avl.imei"
                type="text"
                class="form-control"
                id="imei"
              />
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label for="modelo">Modelo</label>
              <input
                disabled
                v-model="avl.modelo.modelo"
                type="text"
                class="form-control"
                id="modelo"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label for="firmware">Firmware</label>
              <input
                v-model="avl.Firmware"
                type="text"
                class="form-control"
                id="firmware"
              />
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label for="ubicacion">Ubicación</label>
              <input
                v-model="avl.ubicacion"
                type="text"
                class="form-control"
                id="ubicacion"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label for="bateria">Bateria</label>
              <input
                type="text"
                class="form-control"
                v-model="avl.bateria"
                id="bateria"
              />
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label for="estado">Estado</label>
              <input
                type="text"
                class="form-control"
                v-model="avl.estado"
                id="estado"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="comentario">Comentario</label>
              <textarea
                class="form-control"
                v-model="avl.comentario"
                id="comentario"
              ></textarea>
            </div>
          </div>
        </div>
      </div>

      <div class="w-100 d-flex justify-content-end">
        <button type="button" class="btn btn-danger" @click="closeModal">
          Cancelar
        </button>
        <button type="submit" class="btn btn-primary">Guardar</button>
      </div>
    </form>
  </b-modal>
</template>

<script>
import axios from "axios";

export default {
  name: "ModificarAvl",
  computed: {
    avl: {
      get() {
        return this.$store.state.avls.avlForModify;
      },
      set(val) {
        this.$store.commit("avls/setAvlForModify", val);
      },
    },
  },
  watch: {
    avl: {
      handler(newVal) {
        this.$store.commit("avls/setAvlForModify", newVal);
      },
      deep: true,
    },
  },
  methods: {
    async submit() {
      const fd = new FormData();
      fd.append("avl", JSON.stringify(this.avl));
      fd.append("_method", "patch");

      return axios.post(`/avl/${this.avl.id_avl}`, fd).then((response) => {
        this.$emit("avlUpdated", response.data);
        this.closeModal();
      });
    },
    reset() {
      this.$store.commit("avls/setAvlForModify", null);
    },
    closeModal() {
      this.$refs.modal.hide();
    },
  },
};
</script>

<style scoped></style>
